
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface RefundHistory {
  id: string;
  booking_id: string;
  stripe_refund_id: string;
  amount: number;
  status: string;
  reason: string;
  created_at: string;
  updated_at: string;
}

export const useRefundHistory = (bookingId?: string) => {
  return useQuery({
    queryKey: ["refund-history", bookingId],
    queryFn: async () => {
      if (!bookingId) {
        throw new Error("Booking ID is required");
      }

      console.log("Fetching refund history for booking:", bookingId);
      
      // Use any type assertion since refunds table is not in generated types yet
      const { data: refunds, error } = await (supabase as any)
        .from('refunds')
        .select('*')
        .eq('booking_id', bookingId)
        .order('created_at', { ascending: false });

      if (error) {
        console.error('Error fetching refund history:', error);
        // Return empty array instead of throwing to prevent UI errors
        return [];
      }

      console.log('Refund history fetched:', refunds);
      // Type assertion is safe here since we know the structure matches RefundHistory
      return (refunds || []) as RefundHistory[];
    },
    enabled: !!bookingId,
  });
};
